import { createContext, useEffect, useReducer } from "react"


export const ThemeContext = createContext()

const INITIAL_STATE = {
  darkMode: localStorage.getItem("darkMode") === "true"? true : false,
  }   

const themeReducer = (state, action)=>{
  switch(action.type){
    case "TOGGLE":
      const newMode = !state.darkMode;
      localStorage.setItem("darkMode", newMode);
      return{darkMode: newMode};
    default:
      return state;
  }
}

export const ThemeProvider =(props)=>{
  const [state, dispatch] = useReducer (themeReducer, INITIAL_STATE);

  useEffect(() => {
    localStorage.setItem("darkMode", state.darkMode);
  }, [state.darkMode]);

  return(
    <ThemeContext.Provider value={{state,dispatch}}>
      {props.children}
    </ThemeContext.Provider>
  )
}